"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MeetingEnded = require("./MeetingEnded");
Object.keys(_MeetingEnded).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MeetingEnded[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MeetingEnded[key];
    }
  });
});
var _AudioInputFailed = require("./AudioInputFailed");
Object.keys(_AudioInputFailed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioInputFailed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioInputFailed[key];
    }
  });
});
var _LoadBroadcastError = require("./LoadBroadcastError");
Object.keys(_LoadBroadcastError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoadBroadcastError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LoadBroadcastError[key];
    }
  });
});
var _CreateMeetingError = require("./CreateMeetingError");
Object.keys(_CreateMeetingError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateMeetingError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CreateMeetingError[key];
    }
  });
});
var _TokenValidationError = require("./TokenValidationError");
Object.keys(_TokenValidationError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenValidationError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TokenValidationError[key];
    }
  });
});
var _UploadErrorForm = require("./UploadErrorForm");
Object.keys(_UploadErrorForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UploadErrorForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UploadErrorForm[key];
    }
  });
});
var _VirtualBackgroundUploadError = require("./VirtualBackgroundUploadError");
Object.keys(_VirtualBackgroundUploadError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VirtualBackgroundUploadError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VirtualBackgroundUploadError[key];
    }
  });
});
var _UnauthorizedError = require("./UnauthorizedError");
Object.keys(_UnauthorizedError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UnauthorizedError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UnauthorizedError[key];
    }
  });
});